<div class="report-layout-tabs" role="tablist" aria-label="Report layouts">
	<div
		class="report-layout-tab-item"
		*ngFor="let layout of layouts"
	>
		<button
			type="button"
			role="tab"
			class="report-layout-tab"
			[class.active]="layout.id === activeLayoutId"
			[attr.aria-selected]="layout.id === activeLayoutId"
			(click)="selectLayout(layout.id)"
		>
			{{ layout.label }}
		</button>

		<button
			*ngIf="hasNotice(layout.id) && layout.id === activeLayoutId"
			type="button"
			class="report-layout-notice"
			aria-label="Row annotation availability"
			[attr.aria-expanded]="isNoticeVisible(layout.id)"
			(click)="toggleNotice(layout.id, $event)"
		>
			<i class="pi pi-info-circle" aria-hidden="true"></i>
		</button>

		<div
			*ngIf="
      hasNotice(layout.id) &&
      layout.id === activeLayoutId &&
      isNoticeVisible(layout.id)"
			class="report-layout-notice-tooltip"
			role="tooltip"
		>
			{{ noticeText }}
		</div>
	</div>
</div>
